<template>
    <p v-if="hasClientData" class="client">
      Client :
      <a v-if="clientInfos"
        :href="clientInfos.acf.lien_site"
        target="_blank"
        rel="noopener noreferrer"
        :title="`voir le site de ${clientTitle}`"
      >
        {{ clientTitle }}
      </a>
    </p>
</template>
<script setup lang='ts'>

import type { ClientData } from '~/types/clients'


const props = defineProps<{
    client : any
}>()

const clientInfos = ref<ClientData | null>(null)
const { getClientById } = useWordpressApi()


if (props.client?.ID) {
  try {
    const res = await getClientById(props.client.ID)
    clientInfos.value = res
  } catch (err: any) {
    clientInfos.value = null
    console.error('Impossible de trouver ce client')
  }
}

const clientTitle = computed(() => {
  return  clientInfos.value ? 
  props.client.post_title
  : ""
})

const hasClientData = computed(() => {
  return !!(clientTitle.value && clientInfos.value?.acf.lien_site)
})
</script>

<style lang="scss">
  .client{
    a{
      color: $text;
      text-decoration: none;
      transition: all .2s;
      &:hover{
        color: $violet;
      }
    }
  }
</style>